// extracted by mini-css-extract-plugin
export var barContainer = "_2u-0";
export var extraThin = "_2u-3";
export var fillBar = "_2u-6";
export var fillContainer = "_2u-4";
export var overflow = "_2u-8";
export var overflowContainer = "_2u-5";
export var regular = "_2u-7";
export var thick = "_2u-1";
export var thin = "_2u-2";